/*eslint max-lines-per-function: ["error", 700]*/
import React, { JSX } from 'react';
import * as Icon from 'react-bootstrap-icons';
import { matchPath } from 'react-router';
import { useNavigate } from 'react-router-dom';

import { PasswordResetView } from '../app/containers/PasswordResetView';
import { RegisterView } from '../app/containers/RegisterView';
import { SignInView } from '../app/containers/SignInView';
import { ArticlesView } from '../spd/containers/ArticlesView/ArticlesView';
import { BatteriesView } from '../spd/containers/BatteriesView/BatteriesView';
import { CardsView } from '../spd/containers/CardsView/CardsView';
import { ChangeEmailView } from '../spd/containers/ChangeEmailView/ChangeEmailView';
import { ChangePasswordView } from '../spd/containers/ChangePasswordView/ChangePasswordView';
import { ExamCardsView } from '../spd/containers/ExamCardsView/ExamCardsView';
import { ExaminedsView } from '../spd/containers/ExaminedsView/ExaminedsView';
import { ExamJudgmentsDoctorView } from '../spd/containers/ExamJudgmentsView/ExamJudgmentsDoctorView';
import { ExamJudgmentsPsychologistView } from '../spd/containers/ExamJudgmentsView/ExamJudgmentsPsychologistView';
import { ExamsDoctorView } from '../spd/containers/ExamsView/ExamsDoctorView';
import { ExamsPsychologistView } from '../spd/containers/ExamsView/ExamsPsychologistView';
import { ExamsView } from '../spd/containers/ExamsView/ExamsView';
import { ExamsOnlineView } from '../spd/containers/ExamsView/ExamsOnlineView';
import { ExamsInFacilityView } from '../spd/containers/ExamsView/ExamsInFacilityView';
import { ExamsByTestView } from '../spd/containers/ExamsView/ExamsByTestView';
import { ExamTestsView } from '../spd/containers/ExamTestsView/ExamTestsView';
import { IndicatorTestsInExamView } from '../spd/containers/IndicatorTestInExamView/IndicatorTestsInExamView';
import { IndicatorTestsView } from '../spd/containers/IndicatorTestsView/IndicatorTestsView';
import { JudgmentsView } from '../spd/containers/JudgmentsView/JudgmentsView';
import { KeyTestsView } from '../spd/containers/KeyTestsView/KeyTestsView';
import { KeyTestView } from '../spd/containers/KeyTestsView/KeyTestView';
import { LandingView } from '../spd/containers/LandingView/LandingView';
import { NormsView } from '../spd/containers/NormsView/NormsView';
import { NormView } from '../spd/containers/NormsView/NormView';
import { ResultsView } from '../spd/containers/ResultsView/ResultsView';
import { TestGivingModeView } from '../spd/containers/TestGivingModeView/TestGivingModeView';
import { TestGivingView } from '../spd/containers/TestGivingView/TestGivingView';
import { TestView } from '../spd/containers/TestsView/TestView';
import { UnauthorizedView } from '../spd/containers/UnauthorizedView/UnauthorizedView';
import { UsersView } from '../spd/containers/UsersView/UsersView';
import { ExamEditorView } from '../spd/containers/ExamsView/ExamEditorView';
import { ConsultationsView } from '../spd/containers/ConsultationsView/ConsultationsView';
import { ExamConsultationsView } from '../spd/containers/ExamConsultationsView/ExamConsultationsView';
import { AttachmentsView } from '../spd/containers/AttachmentsView/AttachmentsView';
import { ExamsPackageView } from '../spd/containers/ExamsPackageView/ExamsPackageView';
import { CompaniesView } from '../spd/containers/CompaniesView/CompaniesView';
import { ExamsInPackageView } from '../spd/containers/ExamsView/ExamsInPackageView';
import { RegistersView } from '../spd/containers/RegistersView/RegistersView';
import { JudgmentsForRegisterView } from '../spd/containers/RegistersView/JudgmentsForRegisterView';
import { SavePinView } from '../spd/containers/SavePinView/SavePinView';
import { JudgmentsNumberingView } from '../spd/containers/JudgmentsNumberingView/JudgmentsNumberingView';
import { RegisterNumberingView } from '../spd/containers/RegisterNumberingView/RegisterNumberingView';
import { EmailsView } from '../spd/containers/EmailsView/EmailsView';
import { DocumentsForSigningView } from '../spd/containers/JudgmentsView/DocumentsForSigningView';
import { ExamsOphthalmologistView } from '../spd/containers/ExamsView/ExamsOphthalmologistView';
import { HealthcareFacilitiesView } from '../spd/containers/HealthcareFacility/HealthcareFacilitiesView';
import { FiscalPrinterLocationsView } from '../spd/containers/FiscalPrinterLocationView/FiscalPrinterLocationsView';
import { InvoiceIssuersView } from '../spd/containers/InvoiceIssuerView/InvoiceIssuersView';
import { DocumentationView } from '../app/containers/DocumentationView';
import { InstructionView } from '../app/containers/InstructionView';
import { ExamsForExaminedView } from '../spd/containers/ExamsView/ExamForExamined';
import { AccessView } from '../spd/containers/AccessView/AccessView';
import { GenerateExternalReferralView } from '../spd/containers/ExternalReferral/GenerateExternalReferralView';
import { ExternalVisitBookingCalendarView } from '../spd/containers/ExternalVisitBooking/ExternalVisitBookingCalendarView';
import { HarmfulFactorsView } from '../spd/containers/HarmfulFactorView/HarmfulFactorsView';
import { DutiesView } from '../spd/containers/DutyView/DutiesView';
import { JobPositionsView } from '../spd/containers/JobPositionView/JobPositionsView';
import { ReportJudgmentsView } from '../spd/containers/ReportsView/ReportJudgmentsView';
import { ReportConsultationsView } from '../spd/containers/ReportsView/ReportConsultationsView';
import { ReportCompaniesView } from '../spd/containers/ReportsView/ReportCompaniesView';
import { SupportingExaminationDictView } from '../spd/containers/SupportingExaminationDictView/SupportingExaminationDictView';
import { MergeExaminedView } from '../spd/containers/ExaminedsView/MergeExaminedView';
import { ReportCompaniesDetailsView } from '../spd/containers/ReportsView/ReportCompaniesDetailsView';
import { JudgmentsWithoutElectronicSignView } from '../spd/containers/JudgmentsView/JudgmentsWithoutElectronicSignView';
import { ReportJudgmentsByCreatorView } from '../spd/containers/ReportsView/ReportJudgmentsByCreatorView';
import { ReferralsView } from '../spd/containers/ReferralsView/ReferralsView';
import { CalendarView } from '../spd/containers/CalendarView/CalendarView';
import { ExamsTypesView } from '../spd/containers/ExamsTypesView/ExamsTypesView';
import { AppointmentChannelsView } from '../spd/containers/AppointmentChannelsView/AppointmentChannelsView';
import { ChangeLogView } from '../app/containers/ChangeLogView';
import { ExamTypesCategoriesView } from '../spd/containers/ExamTypeCategoryView/ExamTypesCategoriesView';
import { StethoView } from '../spd/containers/StethoView/StethoView';
import { ChangeLogExternalView } from '../app/containers/ChangeLogExternalView';
import { VisitRegistrationsView } from '../spd/containers/RegistrationsView/VisitRegistrationView';
import { TestGivingWithRegistrationView } from '../spd/containers/RegistrationsView/TestGivingWithRegistrationView';
import { SuperAdminPanelView } from '../spd/containers/SuperAdminPanelView/SuperAdminPanelView';
import { ExternalReferralsForRegistrationView } from '../spd/containers/ExternalReferral/ExternalReferralsForRegistrationView';
import { ExternalReferralsView } from '../spd/containers/ExternalReferral/ExternalReferralsView';
import { ExamConsultationsEditorView } from '../spd/containers/ExamsView/ExamConsultationsEditorView';
import { ExamsLaryngologistView } from '../spd/containers/ExamsView/ExamsLaryngologistView';
import { ExamsNeurologistView } from '../spd/containers/ExamsView/ExamsNeurologistView';
import { ExamsPsychiatristView } from '../spd/containers/ExamsView/ExamsPsychiatristView';
import { PricingGroupView } from '../spd/containers/PricingGroupView/PricingGroupView';
import { PricingView } from '../spd/containers/PricingView/PricingView';
import { ReportBillingSummaryView } from '../spd/containers/ReportsView/ReportBillingSummaryView';
import { ReportCompanySummaryView } from '../spd/containers/ReportsView/ReportCompanySummaryView';
import { ReportCompanyExaminedSummaryView } from '../spd/containers/ReportsView/ReportCompanyExaminedSummaryView';
import { ExamHarmfulFactorsEditorView } from '../spd/containers/ExamsView/ExamHarmfulFactorsEditorView';
import { DownloadsFilesView } from '../spd/containers/DownloadsFilesView/DownloadsFilesView';
import { SynevoView } from '../spd/containers/SynevoView/SynevoView';
import { JobConfigView } from '../spd/containers/JobConfigView/JobConfigView';
import { ExternalReferralsJudgmentsView } from '../spd/containers/ExternalReferral/ExternalReferralsJudgmentsView';
import { StampManagementView } from '../spd/containers/StampManagementView/StampManagementView';
import { UserCertificateView } from '../spd/containers/UserCertificateView/UserCertificateView';
import { ReportSynevoCompaniesView } from '../spd/containers/ReportsView/ReportSynevoCompaniesView';
import { PaymentsView } from '../spd/containers/PaymentsView/PaymentsView';
import { ChatsView } from '../spd/containers/ChatsView/ChatsView';
import { PrinterAdminView } from '../spd/containers/PrinterAdminView/PrinterAdminView';
import { CertificateManagementView } from '../spd/containers/CertificateManagementView/CertificateManagementView';
import { PrinterJpkDocumentView } from '../spd/containers/PrinterJpkDocumentView/PrinterJpkDocumentView';
import { SalesInvoicesView } from '../spd/containers/SalesInvoicesView/SalesInvoicesView';
import { SalesInvoiceEditorView } from '../spd/containers/SalesInvoiceEditorView/SalesInvoiceEditorView';
import { ReportSalesInvoicesView } from '../spd/containers/ReportsView/ReportSalesInvoicesView';
import { DownloadSalesInvoicesView } from '../spd/containers/ReportsView/DownloadSalesInvoicesView';
import { InvoicePaymentsView } from '../spd/containers/InvoicePaymentsView/InvoicePaymentsView';
import { InvoicePaymentEditorView } from '../spd/containers/InvoicePaymentEditorView/InvoicePaymentEditorView';
import { ReceiptsView } from '../spd/containers/ReceiptsView/ReceiptsView';
import { PaymentCollectionsView } from '../spd/containers/PaymentCollectionsView/PaymentCollectionsView';
import { PaymentCollectionPaymentsView } from '../spd/containers/PaymentCollectionsView/PaymentCollectionPaymentsView';
import { OverdueInvoicesView } from '../spd/containers/OverdueInvoicesView/OverdueInvoicesView';
import { CompanyOverdueInvoicesView } from '../spd/containers/CompanyOverdueInvoicesView/CompanyOverdueInvoicesView';
import { DictionariesTreeView } from '../spd/containers/DictionariesView/DictionariesTreeView';
import { ParamsView } from '../spd/containers/ParamsView/ParamsView';
import { ManualsView } from '../spd/containers/ManualsView/ManualsView';
import { ExamsAutomaticJudgmentView } from '../spd/containers/ExamsView/ExamsAutomaticJudgmentView';
import { SimP1DocumentsView } from '../spd/containers/SimP1DocumentsView/SimP1DocumentsView';

import { useAuth } from './hooks/useAuth';
import {
  Role,
  ALL_WORKERS_ROLES,
  ALL_WORKERS_REGISTRATION,
  MEDICAL_ROLES,
} from './spdCore/authorization/roles';
import { useCookies } from './hooks/useCookies';
import { useNotifications } from './hooks/useNotifications';
import { ArticleMode } from './spdCore/validation/schemas';

export interface MenuItem {
  hr?: boolean;
  heading?: string;
  path: string;
  skipRegistration?: boolean;
  icon?: Icon.Icon;
  element?: JSX.Element;
  requiredRole?: Role[];
  submenu?: MenuItem[];
  className?: string;
}

export const routesInMenu: MenuItem[] = [
  {
    heading: 'Wizyty - partnerzy',
    path: '/wizyty-partnerzy',
    requiredRole: [Role.ExternalVisitBooking],
    submenu: [
      {
        heading: 'Kalendarz',
        path: '/wizyty-partnerzy/kalendarz',
        element: React.createElement(ExternalVisitBookingCalendarView),
        requiredRole: [Role.ExternalVisitBooking],
      },
    ],
  },
  {
    heading: 'Skierowania zewnętrzne',
    path: '/skierowania-zewnetrzne',
    requiredRole: [Role.ExternalRegistration],
    submenu: [
      {
        heading: 'Wystawianie',
        path: '/skierowania-zewnetrzne/wystawianie',
        element: React.createElement(GenerateExternalReferralView),
        requiredRole: [Role.ExternalRegistration],
      },
      {
        heading: 'Lista utworzonych skierowań',
        path: '/skierowania-zewnetrzne/lista-skierowan',
        element: React.createElement(ExternalReferralsView),
        requiredRole: [Role.ExternalRegistration],
      },
      {
        heading: 'Lista wystawionych orzeczeń',
        path: '/skierowania-zewnetrzne/lista-orzeczen',
        element: React.createElement(ExternalReferralsJudgmentsView),
        requiredRole: [Role.ExternalRegistration],
      },
    ],
  },
  {
    heading: 'Rejestracja',
    path: '/registration',
    requiredRole: [
      Role.MedicalRegistration,
      Role.Admin,
      Role.Office,
      Role.ExtendedRegistration,
    ],
    submenu: [
      {
        heading: 'Badani',
        path: '/badani',
        element: React.createElement(ExaminedsView),
        requiredRole: [
          Role.PsychologistAssessor,
          Role.PsychologistSpecialist,
          Role.MedicalAssessor,
          Role.MedicalSpecialist,
          Role.MedicalRegistration,
          Role.Admin,
          Role.Office,
          Role.ExtendedRegistration,
        ],
      },
      {
        heading: 'Zadawanie testów',
        path: '/chooseTestGiving',
        element: React.createElement(TestGivingModeView),
        requiredRole: [
          Role.MedicalRegistration,
          Role.Admin,
          Role.Office,
          Role.ExtendedRegistration,
        ],
        submenu: [],
      },
      {
        heading: 'Rejestracja',
        path: '/registrations',
        element: React.createElement(VisitRegistrationsView),
        requiredRole: [
          Role.MedicalRegistration,
          Role.Admin,
          Role.Office,
          Role.ExtendedRegistration,
        ],
        submenu: [],
      },
      {
        hr: true,
        path: '',
        requiredRole: [Role.Admin],
      },
      {
        heading: 'Kalendarz dni roboczych',
        path: '/calendar',
        element: React.createElement(CalendarView),
        requiredRole: [Role.Admin],
        submenu: [],
      },
      {
        heading: 'Kategorie typów badań',
        path: '/examTypesCategories',
        element: React.createElement(ExamTypesCategoriesView),
        requiredRole: [Role.Admin],
        submenu: [],
      },
      {
        heading: 'Typy badań',
        path: '/examTypes',
        element: React.createElement(ExamsTypesView),
        requiredRole: [Role.Admin],
        submenu: [],
      },
      {
        heading: 'Kanały rezerwacji wizyt',
        path: '/appointmentChannels',
        element: React.createElement(AppointmentChannelsView),
        requiredRole: [Role.Admin],
        submenu: [],
      },
    ],
  },
  {
    heading: 'Monitor',
    path: '/monitor',
    element: React.createElement(LandingView),
    requiredRole: ALL_WORKERS_ROLES,
    submenu: [
      {
        heading: 'Monitor - ogólny',
        path: '/monitor-ogolny',
        element: React.createElement(ExamsView),
        requiredRole: [
          Role.PsychologistAssessor,
          Role.PsychologistSpecialist,
          Role.MedicalAssessor,
          Role.MedicalSpecialist,
          Role.MedicalRegistration,
          Role.Admin,
          Role.Office,
          Role.ExtendedRegistration,
        ],
        submenu: [],
      },
      {
        hr: true,
        path: '',
        requiredRole: [Role.MedicalRegistration, Role.Admin],
      },
      {
        heading: 'Monitor - psychologa',
        path: `/monitor-psycholog`,
        element: React.createElement(ExamsPsychologistView),
        requiredRole: [
          Role.PsychologistAssessor,
          Role.PsychologistSpecialist,
          Role.MedicalRegistration,
          Role.Admin,
          Role.Office,
          Role.ExtendedRegistration,
        ],
        submenu: [],
      },
      {
        heading: 'Monitor - lekarza',
        path: '/monitor-lekarz',
        element: React.createElement(ExamsDoctorView),
        requiredRole: [
          Role.MedicalAssessor,
          Role.MedicalSpecialist,
          Role.MedicalRegistration,
          Role.Admin,
          Role.Office,
          Role.ExtendedRegistration,
        ],
        submenu: [],
      },
      {
        heading: 'Monitor - okulisty',
        path: '/monitor-okulista',
        element: React.createElement(ExamsOphthalmologistView),
        requiredRole: [
          Role.Ophthalmologist,
          Role.MedicalRegistration,
          Role.Admin,
          Role.Office,
          Role.ExtendedRegistration,
        ],
        submenu: [],
      },
      {
        heading: 'Monitor - laryngologa',
        path: '/monitor-laryngolog',
        element: React.createElement(ExamsLaryngologistView),
        requiredRole: [
          Role.Laryngologist,
          Role.MedicalRegistration,
          Role.Admin,
          Role.Office,
          Role.ExtendedRegistration,
        ],
        submenu: [],
      },
      {
        heading: 'Monitor - neurologa',
        path: '/monitor-neurolog',
        element: React.createElement(ExamsNeurologistView),
        requiredRole: [
          Role.Neurologist,
          Role.MedicalRegistration,
          Role.Admin,
          Role.Office,
          Role.ExtendedRegistration,
        ],
        submenu: [],
      },
      {
        heading: 'Monitor - psychiatry',
        path: '/monitor-psychiatra',
        element: React.createElement(ExamsPsychiatristView),
        requiredRole: [
          Role.Psychiatrist,
          Role.MedicalRegistration,
          Role.Admin,
          Role.Office,
          Role.ExtendedRegistration,
        ],
        submenu: [],
      },
      {
        hr: true,
        path: '',
        requiredRole: [Role.Admin, Role.MedicalRegistration],
      },
      {
        heading: 'Automatyzacja orzeczeń',
        path: '/monitor/automatyzacja-orzeczen',
        element: React.createElement(ExamsAutomaticJudgmentView),
        requiredRole: [Role.Admin, Role.MedicalRegistration],
        submenu: [],
      },
      {
        hr: true,
        path: '',
        requiredRole: [
          Role.PsychologistAssessor,
          Role.PsychologistSpecialist,
          Role.MedicalAssessor,
          Role.MedicalSpecialist,
          Role.MedicalRegistration,
          Role.Admin,
          Role.Office,
          Role.ExtendedRegistration,
        ],
      },
      {
        heading: 'Skierowania zewnętrzne',
        path: '/monitor/skierowania-zewnetrzne',
        element: React.createElement(ExternalReferralsForRegistrationView),
        requiredRole: [
          Role.MedicalRegistration,
          Role.Admin,
          Role.Office,
          Role.ExtendedRegistration,
        ],
        submenu: [],
      },
      {
        heading: 'Synevo',
        path: '/monitor/synevo',
        element: React.createElement(SynevoView),
        requiredRole: [
          Role.PsychologistAssessor,
          Role.PsychologistSpecialist,
          Role.MedicalAssessor,
          Role.MedicalSpecialist,
          Role.MedicalRegistration,
          Role.Admin,
          Role.Office,
          Role.ExtendedRegistration,
        ],
      },
      {
        heading: 'Badania zdalne',
        path: '/monitor/zdalne',
        element: React.createElement(ExamsOnlineView),
        requiredRole: [
          Role.PsychologistAssessor,
          Role.PsychologistSpecialist,
          Role.MedicalAssessor,
          Role.MedicalSpecialist,
          Role.MedicalRegistration,
          Role.Admin,
          Role.Office,
          Role.ExtendedRegistration,
        ],
        submenu: [],
      },
      {
        heading: 'Badania w placówce',
        path: '/monitor/w-placowce',
        element: React.createElement(ExamsInFacilityView),
        requiredRole: [
          Role.PsychologistAssessor,
          Role.PsychologistSpecialist,
          Role.MedicalAssessor,
          Role.MedicalSpecialist,
          Role.MedicalRegistration,
          Role.Admin,
          Role.Office,
          Role.ExtendedRegistration,
        ],
        submenu: [],
      },
      {
        hr: true,
        path: '',
        requiredRole: [
          Role.PsychologistAssessor,
          Role.PsychologistSpecialist,
          Role.MedicalAssessor,
          Role.MedicalSpecialist,
          Role.MedicalRegistration,
          Role.Admin,
        ],
      },
      {
        heading: 'Podgląd badanych',
        path: '/monitor/podglad-badanych',
        element: React.createElement(ChatsView),
        requiredRole: [
          Role.PsychologistAssessor,
          Role.PsychologistSpecialist,
          Role.MedicalAssessor,
          Role.MedicalSpecialist,
          Role.MedicalRegistration,
          Role.Admin,
        ],
        submenu: [],
      },
    ],
  },
  {
    heading: 'Wydruki',
    path: '/wydruki',
    element: React.createElement(LandingView),
    requiredRole: ALL_WORKERS_ROLES,
    submenu: [
      {
        heading: 'Orzeczenia',
        path: '/orzeczenia',
        element: React.createElement(JudgmentsView),
        requiredRole: ALL_WORKERS_ROLES,
        submenu: [],
      },
      {
        heading: 'Orzeczenia bez podpisu elektronicznego',
        path: '/orzeczenia_bez_podpisu',
        element: React.createElement(JudgmentsWithoutElectronicSignView),
        requiredRole: ALL_WORKERS_ROLES,
        submenu: [],
      },
      {
        heading: 'Orzeczenia wysyłane do SIM',
        path: '/orzeczenia-sim',
        element: React.createElement(SimP1DocumentsView),
        requiredRole: ALL_WORKERS_ROLES,
        submenu: [],
      },
      {
        hr: true,
        path: '',
        requiredRole: ALL_WORKERS_ROLES,
      },
      {
        heading: 'Karty',
        path: '/karty',
        element: React.createElement(CardsView),
        requiredRole: ALL_WORKERS_ROLES,
        submenu: [],
      },
      {
        heading: 'Konsultacje',
        path: '/konsultacje',
        element: React.createElement(ConsultationsView),
        requiredRole: ALL_WORKERS_ROLES,
        submenu: [],
      },
      {
        heading: 'Skierowania',
        path: '/skierowania',
        element: React.createElement(ReferralsView),
        requiredRole: ALL_WORKERS_ROLES,
        submenu: [],
      },
    ],
  },
  {
    heading: 'Rejestry',
    path: '/rejestry',
    skipRegistration: true,
    element: React.createElement(LandingView),
    requiredRole: [
      Role.PsychologistAssessor,
      Role.PsychologistSpecialist,
      Role.MedicalAssessor,
      Role.MedicalSpecialist,
      Role.Admin,
      Role.Office,
    ],
    submenu: [
      {
        heading: 'Dokumenty oczekujące na podpis',
        path: '/dokumenty-do-podpisu',
        element: React.createElement(DocumentsForSigningView),
        requiredRole: [
          Role.PsychologistAssessor,
          Role.PsychologistSpecialist,
          Role.MedicalAssessor,
          Role.MedicalSpecialist,
          Role.Admin,
          Role.Office,
        ],
        submenu: [],
      },
      {
        hr: true,
        path: '',
        requiredRole: [
          Role.PsychologistAssessor,
          Role.PsychologistSpecialist,
          Role.Admin,
          Role.Office,
        ],
      },
      {
        heading: 'Psycholodzy - orzeczenia kierowców',
        path: `/rejestr-orzeczen/OK`,
        element: React.createElement(JudgmentsForRegisterView),
        requiredRole: [
          Role.PsychologistAssessor,
          Role.PsychologistSpecialist,
          Role.Admin,
          Role.Office,
        ],
        submenu: [],
      },
      {
        heading: 'Psycholodzy - medycyna pracy',
        path: `/rejestr-orzeczen/KMP`,
        element: React.createElement(JudgmentsForRegisterView),
        requiredRole: [
          Role.PsychologistAssessor,
          Role.PsychologistSpecialist,
          Role.Admin,
          Role.Office,
        ],
        submenu: [],
      },
      {
        heading: 'Psycholodzy - broń',
        path: `/rejestr-orzeczen/BR`,
        element: React.createElement(JudgmentsForRegisterView),
        requiredRole: [
          Role.PsychologistAssessor,
          Role.PsychologistSpecialist,
          Role.Admin,
          Role.Office,
        ],
        submenu: [],
      },
      {
        hr: true,
        path: '',
        requiredRole: [
          Role.MedicalAssessor,
          Role.MedicalSpecialist,
          Role.Admin,
          Role.Office,
        ],
      },
      {
        heading: 'Lekarze - kierowcy z art. 75',
        path: '/rejestr-orzeczen/K75',
        element: React.createElement(JudgmentsForRegisterView),
        requiredRole: [Role.MedicalAssessor, Role.Admin, Role.Office],
        submenu: [],
      },
      {
        heading: 'Lekarze - medycyna pracy',
        path: '/rejestr-orzeczen/K43',
        element: React.createElement(JudgmentsForRegisterView),
        requiredRole: [Role.MedicalAssessor, Role.Admin, Role.Office],
        submenu: [],
      },
      {
        heading: 'Lekarze - sanitarny',
        path: '/rejestr-orzeczen/KS',
        element: React.createElement(JudgmentsForRegisterView),
        requiredRole: [Role.MedicalAssessor, Role.Admin, Role.Office],
        submenu: [],
      },
      {
        heading: 'Lekarze - uczniowie i studenci',
        path: '/rejestr-orzeczen/KU',
        element: React.createElement(JudgmentsForRegisterView),
        requiredRole: [Role.MedicalAssessor, Role.Admin, Role.Office],
        submenu: [],
      },
      {
        heading: 'Lekarze - broń',
        path: '/rejestr-orzeczen/LBR',
        element: React.createElement(JudgmentsForRegisterView),
        requiredRole: [
          Role.MedicalAssessor,
          Role.MedicalSpecialist,
          Role.Admin,
          Role.Office,
        ],
        submenu: [],
      },
    ],
  },
  {
    heading: 'Rozliczenia',
    path: '/rozliczenia',
    skipRegistration: true,
    element: React.createElement(LandingView),
    requiredRole: [
      Role.Admin,
      Role.Finance,
      Role.MedicalRegistration,
      Role.Admin,
      Role.Office,
      Role.ExtendedRegistration,
    ],
    submenu: [
      {
        heading: 'Paczki badań',
        path: '/rozliczenia/paczki',
        element: React.createElement(ExamsPackageView),
        requiredRole: [
          Role.Admin,
          Role.MedicalRegistration,
          Role.Office,
          Role.ExtendedRegistration,
        ],
      },
      {
        heading: 'Firmy',
        path: '/rozliczenia/firmy',
        element: React.createElement(CompaniesView),
        requiredRole: [Role.Admin, Role.Office],
      },
      {
        hr: true,
        path: '',
        requiredRole: [Role.Admin],
      },
      {
        heading: 'Faktury sprzedaży',
        path: '/rozliczenia/faktury-sprzedazy',
        element: React.createElement(SalesInvoicesView),
        requiredRole: [Role.Admin, Role.Finance],
        submenu: [],
      },
      {
        heading: 'Zestawienie faktur sprzedaży',
        path: '/rozliczenia/zestawienie-faktur-sprzedazy',
        element: React.createElement(ReportSalesInvoicesView),
        requiredRole: [Role.Admin, Role.Finance],
        submenu: [],
      },
      {
        heading: 'Pobieranie faktur sprzedaży ',
        path: '/rozliczenia/pobieranie-dokumentow',
        element: React.createElement(DownloadSalesInvoicesView),
        requiredRole: [Role.Admin, Role.Finance],
        submenu: [],
      },
      {
        hr: true,
        path: '',
        requiredRole: [Role.SuperAdmin],
      },
      {
        heading: 'Paragony',
        path: '/rozliczenia/paragony',
        element: React.createElement(ReceiptsView),
        requiredRole: [Role.SuperAdmin],
        submenu: [],
      },
      {
        hr: true,
        path: '',
        requiredRole: [Role.Admin],
      },
      {
        heading: 'Wpłaty',
        path: '/rozliczenia/wplaty',
        element: React.createElement(InvoicePaymentsView),
        requiredRole: [Role.Admin, Role.Finance],
        submenu: [],
      },
      {
        heading: 'Zbiory wpłat',
        path: '/rozliczenia/zbiory-wplat',
        element: React.createElement(PaymentCollectionsView),
        requiredRole: [Role.Admin, Role.Finance],
        submenu: [],
      },
      {
        hr: true,
        path: '',
        requiredRole: [Role.Admin, Role.Finance],
      },
      {
        heading: 'Przeterminowane należności wg firm',
        path: '/rozliczenia/przeterminowane-wg-firm',
        element: React.createElement(OverdueInvoicesView),
        requiredRole: [Role.Admin, Role.Finance],
        submenu: [],
      },
    ],
  },
  {
    heading: 'Zestawienia',
    path: '/zestawienia',
    skipRegistration: true,
    element: React.createElement(LandingView),
    requiredRole: [Role.Admin, Role.Office],
    submenu: [
      {
        heading: 'Orzeczeń',
        path: '/wg-orzeczen',
        element: React.createElement(ReportJudgmentsView),
        requiredRole: [Role.Admin, Role.Office],
        submenu: [],
      },
      {
        heading: 'Konsultacji',
        path: '/wg-konsultacji',
        element: React.createElement(ReportConsultationsView),
        requiredRole: [Role.Admin, Role.Office],
        submenu: [],
      },
      {
        heading: 'Orzeczeń wg firm',
        path: '/wg-firm',
        element: React.createElement(ReportCompaniesView),
        requiredRole: [Role.Admin, Role.Office],
        submenu: [],
      },
      {
        heading: 'Synevo wg firm',
        path: '/synevo-wg-firm',
        element: React.createElement(ReportSynevoCompaniesView),
        requiredRole: [Role.Admin, Role.Office],
        submenu: [],
      },
      {
        hr: true,
        path: '',
        requiredRole: [Role.Admin, Role.Office],
      },
      {
        heading: 'Świadczenia wg firm',
        path: '/zestawienia/podsumowanie-swiadczen-wg-firm',
        element: React.createElement(ReportCompanySummaryView),
        requiredRole: [Role.Admin, Role.Office],
      },
      {
        heading: 'Świadczenia wg firm i badanych',
        path: '/zestawienia/podsumowanie-swiadczen-wg-badanych',
        element: React.createElement(ReportCompanyExaminedSummaryView),
        requiredRole: [Role.Admin, Role.Office],
      },
      {
        heading: 'Kwoty świadczeń wg firm',
        path: '/zestawienia/kwoty-swiadczen-wg-firm',
        element: React.createElement(ReportBillingSummaryView),
        requiredRole: [Role.Admin, Role.Office],
      },
      {
        heading: 'Pobieranie dokumentów',
        path: '/zestawienia/pobieranie-dokumentow',
        element: React.createElement(DownloadsFilesView),
        requiredRole: [Role.Admin, Role.Office],
      },
      {
        hr: true,
        path: '',
        requiredRole: [Role.Admin],
      },
      {
        heading: 'Orzeczeń wg utworzenia',
        path: '/wg-utworzenia',
        element: React.createElement(ReportJudgmentsByCreatorView),
        requiredRole: [Role.Admin],
        submenu: [],
      },
      {
        hr: true,
        path: '',
        requiredRole: [Role.SuperAdmin],
      },
      {
        heading: 'Panel superadministratora',
        path: '/superadmin_panel',
        element: React.createElement(SuperAdminPanelView),
        requiredRole: [Role.SuperAdmin],
        submenu: [],
      },
    ],
  },
  {
    heading: 'Administracja',
    path: '/administracja',
    element: React.createElement(LandingView),
    requiredRole: [
      Role.Admin,
      Role.SuperAdmin,
      Role.MedicalRegistration,
      Role.PsychologistSpecialist,
      Role.Office,
      Role.ExtendedRegistration,
    ],
    submenu: [
      {
        heading: 'Wiadomości e-mail',
        path: '/administracja/emaile',
        element: React.createElement(EmailsView),
        requiredRole: [
          Role.Admin,
          Role.MedicalRegistration,
          Role.Office,
          Role.ExtendedRegistration,
        ],
      },
      {
        heading: 'Płatności z portalu badanego',
        path: '/platnosci',
        element: React.createElement(PaymentsView),
        requiredRole: [Role.Admin, Role.Office, Role.ExtendedRegistration],
      },
      {
        hr: true,
        path: '',
        requiredRole: [Role.Admin],
      },
      {
        heading: 'Zadania cykliczne',
        path: '/administracja/zadania-cykliczne',
        element: React.createElement(JobConfigView),
        requiredRole: [Role.Admin],
      },
      {
        heading: 'Parametry',
        path: '/administracja/parametry',
        element: React.createElement(ParamsView),
        requiredRole: [Role.Admin, Role.SuperAdmin],
      },
      {
        hr: true,
        path: '',
        requiredRole: [Role.Admin],
      },
      {
        heading: 'Artykuły',
        path: '/administracja/artykuly',
        element: React.createElement(ArticlesView),
        requiredRole: [Role.Admin],
      },
      {
        heading: 'Grupy cenowe',
        path: '/administracja/pricing-groups',
        element: React.createElement(PricingGroupView),
        requiredRole: [Role.Admin],
      },
      {
        heading: 'Cenniki',
        path: '/administracja/cenniki',
        element: React.createElement(PricingView),
        requiredRole: [Role.Admin],
      },
      {
        hr: true,
        path: '',
        requiredRole: [Role.Admin],
      },
      {
        heading: 'Czynniki szkodliwe',
        path: '/administracja/czynniki-szkodliwe',
        element: React.createElement(HarmfulFactorsView),
        requiredRole: [Role.SuperAdmin],
      },
      {
        heading: 'Rodzaje badań pomocniczych',
        path: '/administracja/rodzaje-badan-pomocniczych',
        element: React.createElement(SupportingExaminationDictView),
        requiredRole: [Role.SuperAdmin],
      },
      {
        heading: 'Stanowiska predefiniowane',
        path: '/administracja/stanowiska-predefiniowane',
        element: React.createElement(JobPositionsView),
        requiredRole: [Role.Admin],
      },
      {
        heading: 'Słowniki',
        path: '/administracja/slowniki',
        element: React.createElement(DictionariesTreeView),
        requiredRole: [Role.Admin],
      },
      {
        hr: true,
        path: '',
        requiredRole: [Role.Admin],
      },
      {
        heading: 'Rejestry',
        path: '/administracja/rejestry',
        element: React.createElement(RegistersView),
        requiredRole: [Role.Admin],
      },
      {
        heading: 'Numeracja rejestrów',
        path: '/administracja/numeracja-rejestrow',
        element: React.createElement(JudgmentsNumberingView),
        requiredRole: [Role.SuperAdmin],
      },
      {
        hr: true,
        path: '',
        requiredRole: [Role.Admin],
      },
      {
        heading: 'Placówki',
        path: '/administracja/placowki',
        element: React.createElement(HealthcareFacilitiesView),
        requiredRole: [Role.Admin],
      },
      {
        heading: 'Dyżury',
        path: '/administracja/dyzury',
        element: React.createElement(DutiesView),
        requiredRole: [Role.Admin],
      },
      {
        heading: 'Użytkownicy',
        path: '/administracja/uzytkownicy',
        element: React.createElement(UsersView),
        requiredRole: [Role.Admin, Role.Office],
      },
      {
        heading: 'Dostępy',
        path: '/administracja/dostepy',
        element: React.createElement(AccessView),
        requiredRole: [Role.Admin],
      },
      {
        heading: 'Drukarki - certyfikaty',
        path: '/administracja/certyfikaty',
        element: React.createElement(CertificateManagementView),
        requiredRole: [Role.SuperAdmin],
      },
      {
        heading: 'Drukarki - dokumenty',
        path: '/administracja/drukarki-dokumenty',
        element: React.createElement(PrinterJpkDocumentView),
        requiredRole: [Role.Admin, Role.SuperAdmin],
      },
      {
        heading: 'Drukarki - placówki',
        path: '/administracja/drukarki-placowki',
        element: React.createElement(FiscalPrinterLocationsView),
        requiredRole: [Role.Admin],
      },
      {
        heading: 'Wystawcy faktur',
        path: '/administracja/wystawcy-faktur',
        element: React.createElement(InvoiceIssuersView),
        requiredRole: [Role.SuperAdmin],
      },
      {
        hr: true,
        path: '',
        requiredRole: [Role.Admin],
      },
      {
        heading: 'Testy',
        path: '/testy/testy',
        element: React.createElement(TestView),
        requiredRole: [Role.SuperAdmin],
        submenu: [],
      },
      {
        heading: 'Baterie testów',
        path: '/testy/baterie',
        element: React.createElement(BatteriesView),
        requiredRole: [Role.Admin],
        submenu: [],
      },
      {
        heading: 'Klucze',
        path: '/testy/klucze',
        element: React.createElement(KeyTestsView),
        requiredRole: [Role.SuperAdmin],
        submenu: [],
      },
      {
        heading: 'Wskaźniki',
        path: '/testy/wskazniki',
        element: React.createElement(IndicatorTestsView),
        requiredRole: [Role.SuperAdmin],
        submenu: [],
      },
      {
        heading: 'Normy',
        path: '/testy/normy',
        element: React.createElement(NormsView),
        requiredRole: [Role.Admin, Role.PsychologistSpecialist],
        submenu: [],
      },
    ],
  },
  {
    heading: 'Pomoc',
    path: '/pomoc',
    element: React.createElement(LandingView),
    requiredRole: ALL_WORKERS_ROLES,
    submenu: [
      {
        heading: 'Dokumentacja',
        path: `/pomoc/pomoc`,
        element: React.createElement(DocumentationView),
        requiredRole: ALL_WORKERS_ROLES,
      },
      {
        heading: 'Szafir – instalacja podpisu',
        path: `/pomoc/szafir/instalacja`,
        element: React.createElement(InstructionView, {
          filename: 'szafir-instalacja.html',
        }),
        requiredRole: ALL_WORKERS_ROLES,
        submenu: [],
      },
      {
        heading: 'Szafir – weryfikacja podpisu',
        path: `/pomoc/szafir/weryfikacja`,
        element: React.createElement(InstructionView, {
          filename: 'szafir-weryfikacja.html',
        }),
        requiredRole: ALL_WORKERS_ROLES,
        submenu: [],
      },
      {
        heading: 'Szafir – odnowienie podpisu',
        path: `/pomoc/szafir/odnowienie`,
        element: React.createElement(InstructionView, {
          filename: 'szafir-odnowienie.html',
        }),
        requiredRole: ALL_WORKERS_ROLES,
        submenu: [],
      },
      {
        hr: true,
        path: '',
        requiredRole: ALL_WORKERS_REGISTRATION,
      },
      {
        heading: 'Lista zmian - portal wewnętrzny',
        path: `/lista_zmian_portal_wewnetrzny`,
        element: React.createElement(ChangeLogView),
        requiredRole: ALL_WORKERS_ROLES,
        submenu: [],
      },
      ...(process.env.REACT_APP_TEST_CHANGELOG
        ? [
            {
              heading: 'Lista zmian - stanowisko testów',
              path: '/lista_zmian_testy',
              element: React.createElement(ChangeLogExternalView, {
                changelogUrl: process.env.REACT_APP_TEST_CHANGELOG,
              }),
              requiredRole: ALL_WORKERS_ROLES,
              submenu: [],
            },
          ]
        : []),
      ...(process.env.REACT_APP_PORTAL_CHANGELOG
        ? [
            {
              heading: 'Lista zmian - portal badanego',
              path: '/lista_zmian_portal_badanego',
              element: React.createElement(ChangeLogExternalView, {
                changelogUrl: process.env.REACT_APP_PORTAL_CHANGELOG,
              }),
              requiredRole: ALL_WORKERS_ROLES,
              submenu: [],
            },
            {
              hr: true,
              path: '',
              requiredRole: ALL_WORKERS_REGISTRATION,
            },
            {
              heading: 'Drukarka fiskalna',
              path: '/pomoc/drukarka',
              element: React.createElement(PrinterAdminView),
              requiredRole: ALL_WORKERS_REGISTRATION,
            },
          ]
        : []),
      {
        hr: true,
        path: '',
        requiredRole: ALL_WORKERS_REGISTRATION,
      },
      {
        heading: 'Podręczniki do testów',
        path: `/pomoc/podreczniki`,
        element: React.createElement(ManualsView),
        requiredRole: ALL_WORKERS_ROLES,
      },
    ],
  },
];

export const TWO_FACTOR_VERIFY_PATH = '/2fa-verify';

export const routesInLoginMenu: MenuItem[] = [
  {
    heading: 'Zarządzanie pieczątkami',
    path: '/pieczatki',
    element: React.createElement(StampManagementView),
    requiredRole: [...ALL_WORKERS_ROLES, Role.ExternalRegistration],
  },
  {
    heading: 'Zmiana hasła',
    path: '/zmianaHasla',
    element: React.createElement(ChangePasswordView),
    requiredRole: [...ALL_WORKERS_ROLES, Role.ExternalRegistration],
  },
  {
    heading: 'Zmiana e-mail',
    path: '/zmianaEmail',
    element: React.createElement(ChangeEmailView),
    requiredRole: [...ALL_WORKERS_ROLES, Role.ExternalRegistration],
  },
  {
    heading: 'Zapisz PIN',
    path: '/zapiszPin',
    element: React.createElement(SavePinView),
    requiredRole: MEDICAL_ROLES,
  },
  {
    heading: 'Certyfikat SIM',
    path: '/certyfikatSIM',
    element: React.createElement(UserCertificateView),
    requiredRole: [Role.Admin, Role.MedicalAssessor],
  },
];

export const routesOutsideMenu: MenuItem[] = [
  {
    heading: 'SPD',
    path: '/',
    element: React.createElement(LandingView),
  },
  {
    heading: 'Logowanie',
    path: '/login',
    element: React.createElement(SignInView),
  },
  {
    heading: 'Rejestracja',
    path: '/register',
    element: React.createElement(RegisterView),
  },
  {
    heading: 'Reset hasła',
    path: '/passwordReset',
    element: React.createElement(PasswordResetView),
  },
  {
    heading: 'Testy badania',
    path: '/testyBadania/:id/:mode',
    element: React.createElement(ExamTestsView),
  },
  {
    heading: 'Badania z testem',
    path: '/badaniaZTestem/:testId',
    element: React.createElement(ExamsByTestView),
  },
  {
    heading: 'Badania w paczce',
    path: '/badaniaWPaczce/:id',
    element: React.createElement(ExamsInPackageView),
  },
  {
    heading: 'Wyniki',
    path: '/wyniki/:id',
    element: React.createElement(ResultsView),
  },
  {
    heading: 'Wskaźniki',
    path: '/wskazniki/:id',
    element: React.createElement(IndicatorTestsInExamView),
  },
  {
    heading: 'Karta badania',
    path: '/examCards/:type/:id',
    element: React.createElement(ExamCardsView),
  },
  {
    heading: 'Konsultacja',
    path: '/konsultacja/:type/:id',
    requiredRole: [
      Role.MedicalSpecialist,
      Role.MedicalRegistration,
      Role.Admin,
      Role.Office,
      Role.ExtendedRegistration,
    ],
    element: React.createElement(ExamConsultationsView),
  },
  {
    heading: 'Edycja badania',
    path: '/examEditor/:id',
    element: React.createElement(ExamEditorView),
  },
  {
    heading: 'Edycja konsultacji',
    path: '/examConsultationsEditor/:id',
    element: React.createElement(ExamConsultationsEditorView),
  },
  {
    heading: 'Edycja czynników szkodliwych',
    path: '/examHarmfulFactorsEditor/:id',
    element: React.createElement(ExamHarmfulFactorsEditorView),
  },
  {
    heading: 'Załączniki do badanego',
    path: '/attachments/:examinedId',
    element: React.createElement(AttachmentsView),
  },
  {
    heading: 'Badania związane z badanym',
    path: '/examsExamined/:id',
    element: React.createElement(ExamsForExaminedView),
  },
  {
    heading: 'Sklejanie badanego',
    path: '/mergeExamined/:id',
    element: React.createElement(MergeExaminedView),
  },
  {
    heading: 'Orzeczenia psychologiczne do badania',
    path: '/examPsychologistJudgments/:id',
    requiredRole: [
      Role.PsychologistAssessor,
      Role.PsychologistSpecialist,
      Role.MedicalRegistration,
      Role.Admin,
      Role.Office,
      Role.ExtendedRegistration,
    ],
    element: React.createElement(ExamJudgmentsPsychologistView),
  },
  {
    heading: 'Orzeczenia lekarskie do badania',
    path: '/examDoctorJudgments/:id',
    requiredRole: [
      Role.MedicalAssessor,
      Role.MedicalSpecialist,
      Role.MedicalRegistration,
      Role.Neurologist,
      Role.Psychiatrist,
      Role.Ophthalmologist,
      Role.Laryngologist,
      Role.Admin,
      Role.Office,
      Role.ExtendedRegistration,
    ],
    element: React.createElement(ExamJudgmentsDoctorView),
  },
  {
    heading: 'Zadawanie testów',
    path: '/testGiving/:modeOnlyOne',
    requiredRole: [
      Role.MedicalRegistration,
      Role.Admin,
      Role.Office,
      Role.ExtendedRegistration,
    ],
    element: React.createElement(TestGivingView),
  },
  {
    heading: 'Zadawanie testów po rejestracji badanego',
    path: '/testGivingWithRegistration/:visitId',
    requiredRole: [
      Role.MedicalRegistration,
      Role.Admin,
      Role.Office,
      Role.ExtendedRegistration,
    ],
    element: React.createElement(TestGivingWithRegistrationView),
  },
  {
    heading: 'Klucz testu',
    path: '/kluczTestu/:id',
    requiredRole: [Role.Admin],
    element: React.createElement(KeyTestView),
  },
  {
    heading: 'Norma',
    path: '/norma/:id',
    requiredRole: [Role.Admin, Role.PsychologistSpecialist],
    element: React.createElement(NormView),
  },
  {
    heading: 'Brak dostępu',
    path: '/401',
    element: React.createElement(UnauthorizedView),
  },
  {
    heading: 'Rejestr - orzeczeń',
    path: `/rejestr-orzeczen/:registerMode`,
    element: React.createElement(JudgmentsForRegisterView),
  },
  {
    heading: 'Numeracja rejestrów',
    path: '/administracja/rejestry/numeracja/:id',
    element: React.createElement(RegisterNumberingView),
  },
  {
    heading: 'Dokumenty oczekujące na podpis',
    path: `/dokumenty-do-podpisu`,
    element: React.createElement(DocumentsForSigningView),
  },
  {
    heading: 'Raport wg orzeczeń',
    path: `/wg-orzeczen`,
    element: React.createElement(ReportJudgmentsView),
  },
  {
    heading: 'Raport wg konsultacji',
    path: `/wg-konsultacji`,
    element: React.createElement(ReportConsultationsView),
  },
  {
    heading: 'Orzeczeń wg firm',
    path: `/wg-firm`,
    element: React.createElement(ReportCompaniesView),
  },
  {
    heading: 'Synevo wg firm',
    path: `/synevo-wg-firm`,
    element: React.createElement(ReportSynevoCompaniesView),
  },
  {
    heading: 'Raport orzeczeń wg tworzenia',
    path: `/wg-utworzenia`,
    element: React.createElement(ReportJudgmentsByCreatorView),
  },
  {
    heading: 'Szczegóły raportu wg firm',
    path: `/zestawienia/wg-firm/szczegoly/:psychologistId/:companyId/:registerId/:healthcareFacilityId/:dateFromYear/:dateFromMonth/:dateFromDay/:dateToYear/:dateToMonth/:dateToDay/:onlyWithSettlement/:withHealthcareFacility/:withRegister`,
    element: React.createElement(ReportCompaniesDetailsView),
  },
  {
    heading: 'Analiza wyników StethoMe',
    path: '/stetho/podglad/:examId/:testId',
    requiredRole: [
      Role.PsychologistAssessor,
      Role.PsychologistSpecialist,
      Role.MedicalAssessor,
      Role.MedicalSpecialist,
      Role.MedicalRegistration,
      Role.Admin,
      Role.Office,
      Role.ExtendedRegistration,
    ],
    element: React.createElement(StethoView),
  },
  {
    heading: 'Panel superadministratora',
    path: '/superadmin_panel',
    requiredRole: [Role.SuperAdmin],
    element: React.createElement(SuperAdminPanelView),
  },
  {
    heading: 'Podsumowanie świadczeń wg firm',
    path: '/zestawienia/podsumowanie-swiadczen-wg-firm',
    element: React.createElement(ReportCompanySummaryView),
    requiredRole: [Role.Admin, Role.Office],
  },
  {
    heading: 'Podsumowanie świadczeń wg firm i badanych',
    path: '/zestawienia/podsumowanie-swiadczen-wg-badanych',
    element: React.createElement(ReportCompanyExaminedSummaryView),
    requiredRole: [Role.Admin, Role.Office],
  },
  {
    heading: 'Kwoty świadczeń wg firm',
    path: '/zestawienia/kwoty-swiadczen-wg-firm',
    element: React.createElement(ReportBillingSummaryView),
    requiredRole: [Role.Admin, Role.Office],
  },

  {
    heading: 'Pobieranie dokumentów',
    path: '/zestawienia/pobieranie-dokumentow',
    element: React.createElement(DownloadsFilesView),
    requiredRole: [Role.Admin, Role.Office],
  },
  {
    heading: 'Zarządzanie pieczątkami użytkownika',
    path: '/pieczatki/:userId',
    element: React.createElement(StampManagementView),
    requiredRole: [Role.Admin],
  },

  {
    heading: 'Faktury sprzedaży',
    path: '/rozliczenia/faktury-sprzedazy',
    element: React.createElement(SalesInvoicesView),
    requiredRole: [Role.Admin, Role.Finance],
  },

  {
    heading: 'Zestawienie faktur sprzedaży',
    path: '/rozliczenia/zestawienie-faktur-sprzedazy',
    element: React.createElement(ReportSalesInvoicesView),
    requiredRole: [Role.Admin, Role.Finance],
  },

  {
    heading: 'Pobieranie dokumentów - faktury sprzedaży',
    path: '/rozliczenia/pobieranie-dokumentow',
    element: React.createElement(DownloadSalesInvoicesView),
    requiredRole: [Role.Admin, Role.Finance],
  },
  {
    heading: 'Paragony',
    path: '/rozliczenia/paragony',
    element: React.createElement(ReceiptsView),
    requiredRole: [Role.SuperAdmin],
  },
  {
    heading: 'Wpłaty',
    path: '/rozliczenia/wplaty',
    element: React.createElement(InvoicePaymentsView),
    requiredRole: [Role.Admin, Role.Finance],
  },

  {
    heading: 'Zbiory wpłat',
    path: '/rozliczenia/zbiory-wplat',
    element: React.createElement(PaymentCollectionsView),
    requiredRole: [Role.Admin, Role.Finance],
  },

  {
    heading: 'Przeterminowane należności wg firm',
    path: '/rozliczenia/przeterminowane-wg-firm',
    element: React.createElement(OverdueInvoicesView),
    requiredRole: [Role.Admin, Role.Finance],
  },

  {
    heading: 'Nieopłacone faktury firmy',
    path: '/rozliczenia/faktury-firmy/:companyId/:companyName',
    element: React.createElement(CompanyOverdueInvoicesView),
    requiredRole: [Role.Admin, Role.Finance],
  },

  {
    heading: 'Wpłaty w zbiorze',
    path: '/rozliczenia/zbiory-wplat/:collectionId',
    element: React.createElement(PaymentCollectionPaymentsView),
    requiredRole: [Role.Admin, Role.Finance],
  },

  {
    heading: 'Edycja faktury sprzedaży',
    path: '/rozliczenia/faktury-sprzedazy/edytor/:salesInvoiceId?',
    element: React.createElement(SalesInvoiceEditorView),
    requiredRole: [Role.Admin, Role.Finance],
  },

  {
    heading: 'Edycja wpłaty',
    path: '/rozliczenia/wplaty/edytor/:invoicePaymentId?',
    element: React.createElement(InvoicePaymentEditorView),
    requiredRole: [Role.Admin, Role.Finance],
  },

  {
    heading: 'Paczki badań',
    path: '/rozliczenia/paczki',
    element: React.createElement(ExamsPackageView),
    requiredRole: [
      Role.Admin,
      Role.MedicalRegistration,
      Role.Office,
      Role.ExtendedRegistration,
    ],
  },
  {
    heading: 'Firmy',
    path: '/rozliczenia/firmy',
    element: React.createElement(CompaniesView),
    requiredRole: [Role.Admin, Role.Office],
  },

  {
    heading: 'spd',
    path: '*',
    element: React.createElement(LandingView),
  },
];

export const currentMenuItems = (login: boolean, roles?: Role[]) => {
  if (login) {
    return routesInMenu
      .filter(
        position =>
          position.requiredRole === null ||
          (position.requiredRole &&
            roles &&
            position.requiredRole.some(role => roles.includes(role))),
      )
      .map(position => ({
        ...position,
        submenu: position.submenu
          ? position.submenu.filter(
              subposition =>
                !subposition.requiredRole ||
                subposition.requiredRole.some(role => roles?.includes(role)),
            )
          : [],
      }));
  }

  return [] as MenuItem[];
};

export const getCurrentMenuItem = (activePage: string) => {
  const items: MenuItem[] = [];

  const menu = routesInMenu.concat(routesInLoginMenu).concat(routesOutsideMenu);

  for (const position of menu) {
    if (matchPath(activePage, position.path)) {
      items.push(position);
    }
    for (const subposition of position.submenu || []) {
      if (matchPath(activePage, subposition.path)) {
        items.push(subposition);
      }
    }
  }
  return items;
};

export const currentProfileMenuItems = (activePage: string, roles?: Role[]) => {
  const items: MenuItem[] = [];
  for (const position of routesInLoginMenu) {
    if (
      position.requiredRole === null ||
      (position.requiredRole &&
        roles &&
        position.requiredRole.some(item => roles.includes(item)))
    ) {
      items.push(position);

      for (const subposition of position.submenu || []) {
        if (matchPath(activePage, subposition.path)) {
          items.push(subposition);
        }
      }
    }
  }
  return items;
};

export const useNavigation = () => {
  const URL_DEFAULT = '/start';
  const URL_PSYCHOLOGIST = '/badania';
  const URL_UNAUTHORIZED = '/401';
  const URL_EXAMINED = process.env.REACT_APP_TEST_APP_URL;

  const navigate = useNavigate();
  const auth = useAuth();
  const cookies = useCookies();
  const notifications = useNotifications();

  const checkAccess = (roles: Role[], url: string) => {
    if (!auth.check(roles)) {
      notifications.unauthorized();
      // to de facto nie działa, bo ten kod jest i był wyłączony
      //   return navigate(<Alert variant="danger">
      //   <Alert.Heading>Brak wymaganych uprawnień</Alert.Heading>
      //   <hr />
      //   <p>
      //     W celu podwyższenia uprawnień prosimy o kontakt z administracją.
      //   </p>
      // </Alert>)
      return;
    }
    void navigate(url);
  };

  const chooseStartPage = (
    urlDefault: string,
    urlStaff: string,
    urlUnauthorized: string,
    urlExamined?: string,
  ) => {
    if (
      auth.check([
        Role.PsychologistAssessor,
        Role.PsychologistSpecialist,
        Role.MedicalAssessor,
        Role.MedicalSpecialist,
        Role.MedicalRegistration,
      ])
    ) {
      void navigate(urlStaff);
    } else if (auth.check([Role.Examined])) {
      window.open(urlExamined, '_self');
    } else if (auth.check([Role.Inactive])) {
      window.open(urlUnauthorized, '_self');
    } else {
      void navigate(urlDefault);
    }
    return;
  };

  const chooseMonitor = (mode?: ArticleMode) => {
    let modeToChoose = mode;
    let url = '';
    let roles = [];

    if (!mode) {
      switch (cookies.activeMonitor) {
        case 'psychologist':
          modeToChoose = ArticleMode.Psychologist;
          break;
        case 'doctor':
          modeToChoose = ArticleMode.Doctor;
          break;
        case 'ophthalmologist':
          modeToChoose = ArticleMode.Ophthalmologist;
          break;
      }
    }

    switch (modeToChoose) {
      case ArticleMode.Psychologist:
        url = '/monitor-psycholog';
        roles = [
          Role.PsychologistAssessor,
          Role.PsychologistSpecialist,
          Role.MedicalRegistration,
        ];
        break;

      case ArticleMode.Doctor:
        url = '/monitor-lekarz';
        roles = [
          Role.MedicalAssessor,
          Role.MedicalSpecialist,
          Role.MedicalRegistration,
        ];
        break;
      case ArticleMode.Ophthalmologist:
        url = '/monitor-okulista';
        roles = [Role.MedicalSpecialist, Role.MedicalRegistration];
        break;

      default:
        url = '/monitor-ogolny';
        roles = [
          Role.PsychologistAssessor,
          Role.PsychologistSpecialist,
          Role.MedicalAssessor,
          Role.MedicalSpecialist,
          Role.MedicalRegistration,
        ];
        break;
    }
    return checkAccess(roles, url);
  };

  const goWith = (
    url: string,
    newWindow?: boolean,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    options?: any,
    roles?: Role[],
  ) => {
    if (roles && !auth.check(roles)) {
      notifications.unauthorized();
      return;
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const actions = (url: string, options?: any) => navigate(url, options);

    if (!newWindow) {
      void actions(url, options);
    } else {
      window.open(url, '_blank');
    }
  };

  return {
    menuItem: (location: string) => navigate(location),
    help: () => navigate('/pomoc'),
    startPage: () =>
      chooseStartPage(
        URL_DEFAULT,
        URL_PSYCHOLOGIST,
        URL_UNAUTHORIZED,
        URL_EXAMINED,
      ),
    login: () => navigate('/login'),
    goBack: () => navigate(-1),
    examined: () =>
      checkAccess(
        [
          Role.PsychologistAssessor,
          Role.PsychologistSpecialist,
          Role.MedicalAssessor,
          Role.MedicalSpecialist,
          Role.MedicalRegistration,
          Role.Office,
          Role.ExtendedRegistration,
        ],
        '/badani',
      ),
    attachments: (id: string) =>
      checkAccess(ALL_WORKERS_ROLES, `/attachments/${id}`),
    examsExamined: (id: string) =>
      checkAccess(
        [
          Role.PsychologistAssessor,
          Role.PsychologistSpecialist,
          Role.MedicalAssessor,
          Role.MedicalSpecialist,
          Role.MedicalRegistration,
          Role.Office,
          Role.ExtendedRegistration,
        ],
        `/examsExamined/${id}`,
      ),
    mergeExamined: (id: string) =>
      checkAccess([Role.Admin], `/mergeExamined/${id}`),
    exams: (mode?: ArticleMode) => chooseMonitor(mode),
    chats: () =>
      window.open(
        `${process.env.REACT_APP_CHAT_APP_URL}/monitor?token=${
          localStorage.getItem('mzt-token') || ''
        }`,
        'blank',
      ),
    examsInPackage: (id: string) =>
      checkAccess(
        [
          Role.PsychologistAssessor,
          Role.PsychologistSpecialist,
          Role.MedicalAssessor,
          Role.MedicalSpecialist,
          Role.MedicalRegistration,
          Role.Office,
          Role.ExtendedRegistration,
        ],
        `/badaniaWPaczce/${id}`,
      ),
    examPsychologistJudgments: (id: string, newWindow?: boolean) =>
      goWith(`/examPsychologistJudgments/${id}`, newWindow, undefined, [
        Role.PsychologistAssessor,
        Role.PsychologistSpecialist,
        Role.MedicalRegistration,
        Role.Office,
        Role.ExtendedRegistration,
      ]),
    examDoctorJudgments: (id: string, newWindow?: boolean) =>
      goWith(`/examDoctorJudgments/${id}`, newWindow, undefined, [
        Role.MedicalAssessor,
        Role.MedicalSpecialist,
        Role.MedicalRegistration,
        Role.Neurologist,
        Role.Psychiatrist,
        Role.Ophthalmologist,
        Role.Laryngologist,
        Role.Office,
        Role.ExtendedRegistration,
      ]),
    examCardsPsychologic: (id: string, newWindow?: boolean) =>
      goWith(
        `/examCards/karta_badania_psychologicznego/${id}`,
        newWindow,
        undefined,
        [
          Role.PsychologistAssessor,
          Role.PsychologistSpecialist,
          Role.MedicalRegistration,
          Role.Office,
          Role.ExtendedRegistration,
        ],
      ),
    examCardsPsychologicWeapon: (id: string, newWindow?: boolean) =>
      goWith(
        `/examCards/bron_karta_badania_psychologicznego/${id}`,
        newWindow,
        undefined,
        [
          Role.PsychologistAssessor,
          Role.PsychologistSpecialist,
          Role.MedicalRegistration,
          Role.Office,
          Role.ExtendedRegistration,
        ],
      ),
    examCardsWeapon: (id: string, newWindow?: boolean) =>
      goWith(`/examCards/karta_broni/${id}`, newWindow, undefined, [
        Role.MedicalAssessor,
        Role.MedicalSpecialist,
        Role.MedicalRegistration,
        Role.Ophthalmologist,
        Role.Laryngologist,
        Role.Psychiatrist,
        Role.Neurologist,
        Role.Office,
        Role.ExtendedRegistration,
      ]),
    examCardsPreventive: (id: string, newWindow?: boolean) =>
      goWith(
        `/examCards/karta_badania_profilaktycznego/${id}`,
        newWindow,
        undefined,
        [
          Role.MedicalAssessor,
          Role.MedicalSpecialist,
          Role.MedicalRegistration,
          Role.Ophthalmologist,
          Role.Laryngologist,
          Role.Psychiatrist,
          Role.Neurologist,
          Role.Office,
          Role.ExtendedRegistration,
        ],
      ),
    examCardsDriver: (id: string, newWindow?: boolean) =>
      goWith(`/examCards/karta_badania_kierowcy/${id}`, newWindow, undefined, [
        Role.MedicalAssessor,
        Role.MedicalSpecialist,
        Role.MedicalRegistration,
        Role.Ophthalmologist,
        Role.Laryngologist,
        Role.Psychiatrist,
        Role.Neurologist,
        Role.Office,
        Role.ExtendedRegistration,
      ]),
    examCardsSanitary: (id: string, newWindow?: boolean) =>
      goWith(
        `/examCards/karta_badania_sanitarno_epidemiologicznego/${id}`,
        newWindow,
        undefined,
        [
          Role.MedicalAssessor,
          Role.MedicalSpecialist,
          Role.MedicalRegistration,
          Role.Ophthalmologist,
          Role.Laryngologist,
          Role.Psychiatrist,
          Role.Neurologist,
          Role.Office,
          Role.ExtendedRegistration,
        ],
      ),
    examCardsSport: (id: string, newWindow?: boolean) =>
      goWith(
        `/examCards/karta_badania_sportowego/${id}`,
        newWindow,
        undefined,
        [
          Role.MedicalAssessor,
          Role.MedicalSpecialist,
          Role.MedicalRegistration,
          Role.Ophthalmologist,
          Role.Laryngologist,
          Role.Psychiatrist,
          Role.Neurologist,
          Role.Office,
          Role.ExtendedRegistration,
        ],
      ),
    examEditor: (id: string) =>
      checkAccess(
        [
          Role.PsychologistAssessor,
          Role.PsychologistSpecialist,
          Role.MedicalAssessor,
          Role.MedicalSpecialist,
          Role.MedicalRegistration,
          Role.Office,
          Role.ExtendedRegistration,
        ],
        `/examEditor/${id}`,
      ),
    examConsultationsEditor: (id: string) =>
      checkAccess(
        [
          Role.PsychologistAssessor,
          Role.PsychologistSpecialist,
          Role.MedicalAssessor,
          Role.MedicalSpecialist,
          Role.MedicalRegistration,
          Role.Office,
          Role.ExtendedRegistration,
        ],
        `/examConsultationsEditor/${id}`,
      ),
    examHarmfulFactorsEditor: (id: string) =>
      checkAccess(
        [
          Role.PsychologistAssessor,
          Role.PsychologistSpecialist,
          Role.MedicalAssessor,
          Role.MedicalSpecialist,
          Role.MedicalRegistration,
          Role.Office,
          Role.ExtendedRegistration,
        ],
        `/examHarmfulFactorsEditor/${id}`,
      ),
    tests: () => checkAccess([Role.Admin], '/testy'),
    testGiving: () =>
      checkAccess(
        [
          Role.PsychologistAssessor,
          Role.PsychologistSpecialist,
          Role.MedicalAssessor,
          Role.MedicalSpecialist,
          Role.MedicalRegistration,
          Role.Office,
          Role.ExtendedRegistration,
        ],
        '/choosetestGiving',
      ),
    testGivingMass: () =>
      checkAccess(
        [Role.Admin, Role.Office, Role.ExtendedRegistration],
        `/testGiving/false`,
      ),
    testGivingIndividual: () =>
      checkAccess(
        [
          Role.MedicalRegistration,
          Role.Admin,
          Role.Office,
          Role.ExtendedRegistration,
        ],
        `/testGiving/true`,
      ),
    testGivingWithRegistration: (visitId: string) =>
      checkAccess(
        [
          Role.Admin,
          Role.MedicalRegistration,
          Role.Office,
          Role.ExtendedRegistration,
        ],
        `/testGivingWithRegistration/${visitId}`,
      ),
    pin: () => checkAccess([Role.Examined], '/pin'),

    profileView: (id: string | undefined) => navigate(`/profile/${id}`),

    passwordReset: () => navigate('/passwordReset'),
    register: () => navigate('/register'),
    examTestsDoctor: (id: string) =>
      checkAccess(
        [
          Role.MedicalAssessor,
          Role.MedicalRegistration,
          Role.Office,
          Role.ExtendedRegistration,
        ],
        `/testyBadania/${id}/Doctor`,
      ),
    examTestsPsychologist: (id: string) =>
      checkAccess(
        [
          Role.PsychologistAssessor,
          Role.PsychologistSpecialist,
          Role.MedicalRegistration,
          Role.Office,
          Role.ExtendedRegistration,
        ],
        `/testyBadania/${id}/Psychologist`,
      ),
    examTestsOphthalmologist: (id: string) =>
      checkAccess(
        [
          Role.MedicalRegistration,
          Role.Ophthalmologist,
          Role.Office,
          Role.ExtendedRegistration,
        ],
        `/testyBadania/${id}/Ophthalmologist`,
      ),
    examTestsLaryngologist: (id: string) =>
      checkAccess(
        [
          Role.MedicalRegistration,
          Role.Laryngologist,
          Role.Office,
          Role.ExtendedRegistration,
        ],
        `/testyBadania/${id}/Laryngologist`,
      ),
    examTestsNeurologist: (id: string) =>
      checkAccess(
        [
          Role.MedicalRegistration,
          Role.Neurologist,
          Role.Office,
          Role.ExtendedRegistration,
        ],
        `/testyBadania/${id}/Neurologist`,
      ),
    examTestsPsychiatrist: (id: string) =>
      checkAccess(
        [
          Role.MedicalRegistration,
          Role.Psychiatrist,
          Role.Office,
          Role.ExtendedRegistration,
        ],
        `/testyBadania/${id}/Psychiatrist`,
      ),
    examTests: (id: string, newWindow?: boolean) =>
      goWith(`/testyBadania/${id}/null`, newWindow, undefined, [
        Role.PsychologistAssessor,
        Role.PsychologistSpecialist,
        Role.MedicalAssessor,
        Role.MedicalRegistration,
        Role.Office,
        Role.ExtendedRegistration,
      ]),
    examsByTest: (testId: string, newWindow?: boolean) =>
      goWith(
        `/badaniaZTestem/${testId}`,
        newWindow,
        undefined,
        ALL_WORKERS_ROLES,
      ),
    results: (id: string) => checkAccess(ALL_WORKERS_ROLES, `/wyniki/${id}`),
    indicatorTestsInExam: (id: string) =>
      checkAccess(ALL_WORKERS_ROLES, `/wskazniki/${id}`),

    keyTest: (id: string) => checkAccess([Role.Admin], `/kluczTestu/${id}`),
    norm: (id: string) =>
      checkAccess([Role.Admin, Role.PsychologistSpecialist], `/norma/${id}`),

    consultationNeurological: (id: string) =>
      checkAccess(
        [
          Role.MedicalSpecialist,
          Role.MedicalRegistration,
          Role.Neurologist,
          Role.Office,
          Role.ExtendedRegistration,
        ],
        `/konsultacja/neurologiczna/${id}`,
      ),
    consultationOphthalmologist: (id: string) =>
      checkAccess(
        [
          Role.MedicalSpecialist,
          Role.MedicalRegistration,
          Role.Ophthalmologist,
          Role.Office,
          Role.ExtendedRegistration,
        ],
        `/konsultacja/okulistyczna/${id}`,
      ),
    consultationENT: (id: string) =>
      checkAccess(
        [
          Role.MedicalSpecialist,
          Role.MedicalRegistration,
          Role.Laryngologist,
          Role.Office,
          Role.ExtendedRegistration,
        ],
        `/konsultacja/laryngologiczna/${id}`,
      ),

    consultationPsychiatric: (id: string) =>
      checkAccess(
        [
          Role.MedicalSpecialist,
          Role.PsychologistSpecialist,
          Role.MedicalRegistration,
          Role.Psychiatrist,
          Role.Office,
          Role.ExtendedRegistration,
        ],
        `/konsultacja/psychiatryczna/${id}`,
      ),

    stethoView: (examId: string, testId: string) =>
      goWith(`/stetho/podglad/${examId}/${testId}`, true),

    reportCompanyDetails: (
      psychologistId?: string,
      companyId?: string,
      registerId?: string,
      healthcareFacilityId?: string,
      dateFromYear?: string,
      dateFromMonth?: string,
      dateFromDay?: string,
      dateToYear?: string,
      dateToMonth?: string,
      dateToDay?: string,
      onlyMonthlySettlement?: boolean,
      newWindow?: boolean,
      withHealthcareFacility?: boolean,
      withRegister?: boolean,
    ) =>
      goWith(
        `/zestawienia/wg-firm/szczegoly/${psychologistId || 'undefined'}/${
          companyId || 'undefined'
        }/${registerId || 'undefined'}/${
          healthcareFacilityId || 'undefined'
        }/${dateFromYear}/${dateFromMonth}/${dateFromDay}/${dateToYear}/${dateToMonth}/${dateToDay}/${onlyMonthlySettlement}/${withHealthcareFacility}/${
          withRegister
        }`,
        newWindow,
      ),

    reload: () => history.go(0),
    stampsEdit: (userId: string) =>
      checkAccess([Role.Admin, Role.Office], `/pieczatki/${userId}`),
    salesInvoices: () =>
      checkAccess([Role.Admin, Role.Finance], '/rozliczenia/faktury-sprzedazy'),
    companyOverdueInvoices: (
      companyId: string,
      companyName: string,
      newWindow?: boolean,
    ) =>
      goWith(
        `/rozliczenia/faktury-firmy/${companyId}/${encodeURIComponent(companyName)}`,
        newWindow,
        undefined,
        [Role.Admin, Role.Finance],
      ),
    salesInvoiceEditor: (id?: string, newWindow?: true) =>
      id
        ? goWith(
            `/rozliczenia/faktury-sprzedazy/edytor/${id}`,
            newWindow,
            undefined,
            [Role.Admin, Role.Finance, Role.BasicFinance],
          )
        : goWith(
            '/rozliczenia/faktury-sprzedazy/edytor',
            newWindow,
            undefined,
            [Role.Admin, Role.Finance, Role.BasicFinance],
          ),
    invoicePayments: () =>
      checkAccess([Role.Admin, Role.Finance], '/rozliczenia/wplaty'),
    invoicePaymentEditor: (id?: string, newWindow?: boolean) =>
      goWith(
        id ? `/rozliczenia/wplaty/edytor/${id}` : '/rozliczenia/wplaty/edytor',
        newWindow,
        undefined,
        [Role.Admin, Role.Finance],
      ),

    paymentCollections: () =>
      checkAccess([Role.Admin, Role.Finance], '/rozliczenia/zbiory-wplat'),
    paymentCollectionPayments: (id: string) =>
      checkAccess(
        [Role.Admin, Role.Finance],
        `/rozliczenia/zbiory-wplat/${id}`,
      ),
    examsPackages: () =>
      checkAccess(
        [
          Role.Admin,
          Role.MedicalRegistration,
          Role.Office,
          Role.ExtendedRegistration,
        ],
        '/rozliczenia/paczki',
      ),
    companies: () =>
      checkAccess([Role.Admin, Role.Office], '/rozliczenia/firmy'),
    registerNumberingAdmin: (facilityId: string) =>
      checkAccess(
        [Role.SuperAdmin],
        `/administracja/rejestry/numeracja/${facilityId}`,
      ),
  };
};
